<template>
  <v-container dark fluid fill-height>
    <v-layout>
      <v-flex>
        <location-list />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LocationList from '@/components/Locations/List'

export default {
  components: {
    LocationList
  }
}
</script>

<style>

</style>
